import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fillRule="evenodd"
      d="M17.972 8.037a2.75 2.75 0 1 0 3.056-4.573 2.75 2.75 0 0 0-3.056 4.573m.833-3.326a1.25 1.25 0 1 1 1.39 2.079 1.25 1.25 0 0 1-1.39-2.08"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M10.909 21.701a2.25 2.25 0 0 0 3.84-1.591V17a1.74 1.74 0 0 0-.2-.82l-1.71-3.32a.26.26 0 0 1 .09-.34l.92-.53a.25.25 0 0 1 .33.08l.51.91a2.73 2.73 0 0 0 2.4 1.42h2.88a2.25 2.25 0 1 0 0-4.5h-1.65a.22.22 0 0 1-.21-.12l-1.27-2.2a2.77 2.77 0 0 0-2.585-1.357l-.404-.683a2.77 2.77 0 0 0-3.77-1L7.2 6.27a2.75 2.75 0 0 0-1 3.76l1.444 2.439q.07.175.166.341l2.27 3.88c.11.192.169.409.17.63v2.79c0 .597.237 1.169.659 1.591M8.809 9.05l4.013-2.32-.252-.44a1.26 1.26 0 0 0-1.73-.48L7.96 7.56a1.25 1.25 0 0 0-.46 1.71l.388.659a2.76 2.76 0 0 1 .922-.879m.144 2.497q.027.213.125.404l.152.259-.003.002 2.153 3.728c.242.42.37.896.37 1.38v2.79a.75.75 0 1 0 1.5 0v-3.15a.3.3 0 0 0 0-.12l-1.75-3.33a1.75 1.75 0 0 1 .67-2.33l.92-.53a1.76 1.76 0 0 1 2.39.64l.51.93a1.24 1.24 0 0 0 1.09.64h2.89a.75.75 0 1 0 0-1.5h-1.64a1.74 1.74 0 0 1-1.51-.87l-1.27-2.2a1.25 1.25 0 0 0-1.05-.62c-.217 0-.43.055-.62.16L9.57 10.3a1.25 1.25 0 0 0-.617 1.247"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M17.045 23.254a4.3 4.3 0 0 0 2.395.726 4.32 4.32 0 0 0 4.31-4.31 4.31 4.31 0 1 0-6.705 3.584m.834-5.92A2.81 2.81 0 1 1 21 22.006a2.81 2.81 0 0 1-3.122-4.672M7.25 15.715V13.61a.76.76 0 0 0-.75-.75h-5a.76.76 0 0 0-.75.75v6a.75.75 0 0 0 .551.723A4.31 4.31 0 0 0 5.56 23.98a4.31 4.31 0 0 0 1.69-8.265M2.836 20.36a2.811 2.811 0 1 0 4.414-2.934v2.184a.75.75 0 0 1-.75.75zm-.586-1.5h3.5v-4.5h-3.5z"
      clipRule="evenodd"
    />
  </>
);

const BikingTouring = Icon('biking-touring', svgContents);

export default BikingTouring;
